import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../landing/landing.css";
import Nav from "../landing/sections/Nav";
import Footer from "../landing/sections/Footer";
import BookDemoModal from "../landing/sections/BookDemoModal";
import { DemoModalProvider } from "../landing/hooks/useDemoModal";

/**
 * Shared shell for public marketing / legal pages.
 * Reuses the landing Nav + Footer so branding stays consistent, and hosts its own
 * DemoModalProvider so the footer "Contact" link (and any inline CTA) can open the demo modal.
 * Content is passed via `title`, `kicker`, `updated`, and `children`.
 */
export default function PublicPage({ kicker, title, updated, children, testid, tabs }) {
    useEffect(() => { window.scrollTo({ top: 0, behavior: "auto" }); }, []);
    return (
        <DemoModalProvider>
            <div className="vy-landing" data-testid={testid || "public-page"}>
                <Nav />
                <main className="vy-container" style={{ paddingTop: 56, paddingBottom: 72, minHeight: "60vh" }}>
                    <div style={{ maxWidth: 760, margin: "0 auto" }}>
                        <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--vy-gold)", fontFamily: "IBM Plex Mono, monospace" }}>
                            {kicker}
                        </div>
                        <h1 className="vy-serif" style={{ fontSize: "2.6rem", marginTop: 10, marginBottom: 8, lineHeight: 1.05, color: "var(--vy-navy)" }} data-testid="public-title">
                            {title}
                        </h1>
                        {updated && (
                            <div style={{ fontSize: 12, color: "rgba(19,25,46,0.55)", fontFamily: "IBM Plex Mono, monospace", marginBottom: 28 }}>
                                Last updated · {updated}
                            </div>
                        )}
                        {tabs}
                        <div className="vy-prose" style={{ fontSize: 15, lineHeight: 1.75, color: "rgba(19,25,46,0.85)" }}>
                            {children}
                        </div>
                        <div style={{ marginTop: 44, paddingTop: 22, borderTop: "1px solid rgba(166,138,86,0.28)", fontSize: 13 }}>
                            <Link to="/" style={{ color: "var(--vy-navy)", fontWeight: 500, textDecoration: "none" }}>&larr; Back to home</Link>
                        </div>
                    </div>
                </main>
                <Footer />
                <BookDemoModal />
            </div>
        </DemoModalProvider>
    );
}
